import PageWrapper from 'core/components/page-wrapper/PageWrapper'
import FAQ from './FAQ'
import AnnualSummary from './AnnualSummary'
import { useQuery } from 'react-query'
import APIService from 'api/APIService'
import { useState } from 'react'
import TaxReportTable from './TaxReportTable'

const TaxInfoPage = () => {
  const [year, setYear] = useState(new Date().getFullYear())

  const { data, status } = useQuery(['AnnualTaxReport', year], () =>
    APIService.misc.getTaxReport({
      year
    })
  )

  return (
    <PageWrapper title="Taxes">
      <div className="md:grid ml:grid-cols-12 gap-6">
        <div className="mb-6 md:cols-span-7 md:mb-0 ml:col-span-8">
          <AnnualSummary
            year={year}
            setYear={setYear}
            summaryData={data?.summary}
            isLoading={status === 'loading'}
          />
        </div>
        <div className="mb-6 md:cols-span-5 md:mb-0 ml:col-span-4">
          <FAQ />
        </div>
        <div className="mb-6 md:mb-0 ml:col-span-12">
          <TaxReportTable taxData={data} status={status} />
        </div>
      </div>
    </PageWrapper>
  )
}

export default TaxInfoPage
